import { Form } from 'element-ui'

const YForm = Form
YForm.$depends = [Form]
YForm.$name = 'y-form'
YForm._name = 'Form 表单'

export default YForm
